import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LoadingStore } from '../../../data/loading/loading.store';

type ButtonCssType = 'btn-primary' | 'btn-secondary' | 'btn-primary-outline' | 'btn-light-outline' | 'btn-link';

// Renders a <button> or an <a>; the cssType string is the global class from styles/buttons.scss.
// Disabled while any HTTP request is in flight, so callers don't track their own loading flags.
@Component({
  selector: 'lib-buttons',
  templateUrl: './button.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, RouterModule],
  // Disabled styles set pointer-events: none on the inner element, so clicks would land on the host's (click).
  host: { '[style.pointer-events]': "disabled() || isLoading() ? 'none' : null" },
})
export class ButtonComponent {
  buttonId = input<string | null>(null);
  cssType = input<ButtonCssType>('btn-primary');
  text = input<string>('');
  buttonType = input<'button' | 'link'>('button');
  type = input<'button' | 'submit' | 'reset'>('button');
  size = input<'small' | 'large' | 'full'>('large');
  externalLink = input<boolean>(false);
  href = input<string | null>(null);
  routerLink = input<string | unknown[] | null>(null);
  queryParams = input<Record<string, string> | null>(null);
  ariaLabel = input<string | null>(null);
  disabled = input<boolean>(false);

  protected isLoading = inject(LoadingStore).isLoading;
  classes = computed(() => [this.cssType(), this.sizeClass(), this.disabled() || this.isLoading() ? 'disabled' : '']);

  private sizeClass(): string {
    switch (this.size()) {
      case 'small':
        return 'btn-small';
      case 'full':
        return 'btn-full';
      default:
        return '';
    }
  }
}
